<template>
  <div class="container-fluid">
    <titular />
    <vue-bootstrap4-table ref="tabla" :rows="rows" :columns="columns" :classes="classes" :config="config" :actions="actionsExportar" @exportarTabla="exportarTablaPrevio" @exportarBolcat="exportarBolcatPrevio">
      <template slot="empty-results">No hi ha cap comunicació.</template>
      <template slot="global-search-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="refresh-button-text">
        <i class="fa-solid fa-rotate" title="Actualitzar dades" @click="getData" v-tooltip></i>
      </template>
      <template slot="reset-button-text">
        <i class="fa-solid fa-eraser" title="Reiniciar vista" v-tooltip></i>
      </template>
      <template slot="sort-asc-icon">
        <i class="fa-solid fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa-solid fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fas fa-sort"></i>
      </template>
      <template slot="simple-filter-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="paginataion-previous-button">
        <i class="fa-solid fa-angle-left"></i>
      </template>
      <template slot="paginataion-next-button">
        <i class="fa-solid fa-angle-right"></i>
      </template>
      <template v-slot:pagination-info="props">
        Registres: {{ props.currentPageRowsLength }} de {{ props.filteredRowsLength }}<template v-if="props.filteredRowsLength !== props.originalRowsLength"> ({{ props.originalRowsLength }} en total)</template>
      </template>
      <template slot="selected-rows-info" slot-scope="props">{{ props }} Selecció: {{ props.selectedItemsCount }}</template>
      <template slot="tipus" slot-scope="props">
        <span class="text-capitalize">{{ props.cell_value }}</span>
      </template>
      <template slot="proyecto" slot-scope="props">
        <router-link :to="{ path: '/recursos-projecte', query: { id: props.row.id_projecte, filtre: 'tot' } }" target="_blank">{{ props.cell_value }}</router-link>
      </template>
    </vue-bootstrap4-table>
  </div>
</template>

<style lang="scss"></style>

<script>
export default {
  name: "ProjectesOblidats",
  inject: ["formatearDecimales", "exportarTabla", "exportarBolcat", "mostrarBolcat", "actionsExportar", "exportarDatos", "formatearFecha"],
  data() {
    return {
      loading: {
        exportacion: false,
      },
      rows: [],
      rowsBuffer: [],
      columns: [
        {
          label: "Data comunicació",
          name: "data_comunicacio",
          filter: {
            type: "simple",
            placeholder: "Filtra data",
          },
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc",
          row_text_alignment: "text-center",
        },
        {
          label: "Client",
          name: "cliente",
          filter: {
            type: "simple",
            placeholder: "Filtra client",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Projecte",
          name: "proyecto",
          filter: {
            type: "simple",
            placeholder: "Filtra projecte",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Responsable",
          name: "trabajador",
          filter: {
            type: "simple",
            placeholder: "Filtra responsable",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Tipus comunicació",
          name: "tipus_comunicacio",
          filter: {
            type: "select",
            mode: "single",
            closeDropdownOnSelection: true,
            placeholder: "Tipus",
            options: [
              {
                name: "Inactivitat",
                value: "inactivitat",
              },
              {
                name: "Venciment",
                value: "venciment",
              },
            ],
          },
          sort: false,
          row_text_alignment: "text-center",
          slot_name: "tipus",
        },
      ],
      classes: {
        cell: {
          "align-middle": true,
        },
      },
      config: {
        card_title: "Totes les comunicacions",
        global_search: {
          placeholder: "Cerca",
        },
        per_page: 25,
        per_page_options: [25, 50, 100],
        num_of_visibile_pagination_buttons: 5,
      },
    };
  },
  methods: {
    getData: function () {
      this.$http.get("api/comunicacions").then((response) => {
        this.rows = response.data.map(row => ({
          ...row,
        }));
      });
    },
    async getExportData() {
      const filas = this.$refs.tabla.temp_filtered_results;

      if (!filas.length) return null;

      const response = await this.$http.get(`api/projectes?consumos`);
      const consumos = filas.map(fila => {
        const consumo = response.data.find(consumo => consumo.id == fila.id_projecte)?.consumo;

        if (!consumo) return null;

        return this.formatearDecimales(consumo, 0);
      });

      var filasCompletas = filas.map((fila, i) => ({
        'data comunicació': fila.data_comunicacio,
        'tipus comunicació': fila.tipus_comunicacio,
        'responsable': fila.trabajador,
        'client': fila.cliente,
        'projecte': fila.proyecto,
        '% recursos consumits': consumos[i],
      }));

      filasCompletas.unshift(Object.keys(filasCompletas[0]));

      return filasCompletas;
    },
    async exportarTablaPrevio() {
      if (this.loading.exportacion) return;

      this.loading.exportacion = true;

      const data = await this.getExportData();

      if (!data) {
        this.loading.exportacion = false;
        return this.$toast.open({ type: "error", position: "top", message: "No hi ha cap comunicació per exportar." });
      }

      this.exportarDatos(this.$route.name, data);

      this.loading.exportacion = false;
    },
    async exportarBolcatPrevio() {
      if (this.loading.exportacion) return;

      this.loading.exportacion = true;

      const data = await this.getExportData();

      if (!data) {
        this.loading.exportacion = false;
        return this.$toast.open({ type: "error", position: "top", message: "No hi ha cap comunicació per exportar." });
      }

      this.mostrarBolcat(this.$route.name, data);

      this.loading.exportacion = false;
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    "loading.exportacion"(value) {
      document.querySelector(".exportar-bolcat").disabled = value;

      document.querySelector(".exportar-bolcat .spinner-border").classList.toggle('d-none');
      document.querySelector(".exportar-bolcat i").classList.toggle('d-none');
    },
    rows: function (value) {
      this.rowsBuffer = structuredClone(value);
    },
  },
};
</script>